import { NotificationTopicOwnersSettingsSection } from "@/components/NotificationTopicOwnersSettingsSection";
import { PageTitleWithHelp } from "@/components/ui/title-help";
import { apiFetch } from "@/lib/api";
import { useHubModuleAdmin } from "@/lib/useHubModuleAdmin";

import { InboundIqcRulesCard } from "./InboundIqcRulesCard";

const NOTIFICATION_STAFF_USERS_QUERY_KEY = ["notifications", "staff-user-options"] as const;

function fetchNotificationStaffUsers(): Promise<{
  users: Array<{ userId: string; email: string; displayName: string | null }>;
}> {
  return apiFetch("/api/notifications/staff-user-options");
}

export function ShippingSettingsPage() {
  const canEdit = useHubModuleAdmin("shipping");

  return (
    <div className="space-y-4">
      <header>
        <PageTitleWithHelp hoverHint="Shipping module settings: inbound IQC rules, paperwork topic owners, and other operational configuration for outbound, inbound, and customer paperwork workflows.">
          Shipping · Settings
        </PageTitleWithHelp>
      </header>

      <InboundIqcRulesCard canEdit={canEdit} />

      <NotificationTopicOwnersSettingsSection
        topic="shipping_paperwork"
        title="Paperwork topic owners"
        hoverHint="Hub users in this group receive email and in-app notifications when tracking is added to an outbound shipment so paperwork can be sent to the customer."
        canEdit={canEdit}
        userOptionsQueryKey={NOTIFICATION_STAFF_USERS_QUERY_KEY}
        fetchUserOptions={fetchNotificationStaffUsers}
        readOnlyHoverHint="Shipping module administrators can edit this topic owner group."
      />

      <NotificationTopicOwnersSettingsSection
        topic="shipping_inbound_arrival"
        title="Arrivals distribution list"
        hoverHint="Hub users in this group receive email and in-app notifications when a new inbound dock arrival is logged."
        canEdit={canEdit}
        userOptionsQueryKey={NOTIFICATION_STAFF_USERS_QUERY_KEY}
        fetchUserOptions={fetchNotificationStaffUsers}
        readOnlyHoverHint="Shipping module administrators can edit this distribution list."
      />
    </div>
  );
}
